import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy, memo } from 'react';

const LazyStudentPersonalAccount = lazy(() =>
  import('./studentPersonalAccount')
    .then((module) => ({ default: module.StudentPersonalAccount }))
    .catch(() => {
      document.location.reload();
      return { default: memo(() => <></>) };
    })
);

export const StudentPersonalAccount = (): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyStudentPersonalAccount />
  </Suspense>
);
